import React, { useState } from 'react';
import { Plus, Edit2, Trash2, Users } from 'lucide-react';

export default function GroupMaster() {
  const [data, setData] = useState([
    { id: 1, code: 'GENERAL', name: 'GENERAL', prefix: '', type: '', sales: '', comn: '' },
    { id: 2, code: 'GENUINE', name: 'GENUINE', prefix: '', type: '', sales: '', comn: '' },
    { id: 3, code: 'HVAC', name: 'HVAC', prefix: '', type: '', sales: '', comn: '' },
    { id: 4, code: 'NON-GENUINE', name: 'NON-GENUINE', prefix: '', type: '', sales: '', comn: '' }
  ]);

  const [form, setForm] = useState({ code: '', name: '', prefix: '' });
  const [selectedId, setSelectedId] = useState(null);

  const handleRowClick = (item) => {
    setSelectedId(item.id);
    setForm({ code: item.code, name: item.name, prefix: item.prefix });
  };

  const clearForm = () => {
    setForm({ code: '', name: '', prefix: '' });
    setSelectedId(null);
  };

  return (
    <div className="w-full max-w-5xl bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      {/* Header Banner */}
      <div className="bg-slate-50 border-b border-slate-200 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg">
            <Users size={20} />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-800 capitalize">Group Directory</h2>
            
          </div>
        </div>
      </div>

      {/* Dynamic Action & Form Area */}
      <div className="p-6 border-b border-slate-100 bg-slate-50/50 flex flex-col lg:flex-row gap-6 items-end">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Group Code</label>
            <input type="text"  value={form.code} onChange={e => setForm({...form, code: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition-all" />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Prefix</label>
            <input type="text" value={form.prefix} onChange={e => setForm({...form, prefix: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition-all" />
          </div>
          <div className="flex flex-col gap-1.5 md:col-span-1">
            <label className="text-xs font-semibold text-slate-600">Group Name</label>
            <input type="text"  value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition-all" />
          </div>
        </div>

        {/* Action Button Set */}
        <div className="flex gap-2 w-full lg:w-auto shrink-0">
          <button onClick={() => { setData([...data, { id: Date.now(), ...form, type: '', sales: '', comn: '' }]); clearForm(); }} disabled={!!selectedId} className="flex-1 lg:flex-none flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-200 disabled:text-slate-400 text-white font-medium text-sm py-2 px-4 rounded-lg transition-colors shadow-sm"><Plus size={16} /><span>Add</span></button>
          <button onClick={() => { setData(data.map(d => d.id === selectedId ? { ...d, ...form } : d)); clearForm(); }} disabled={!selectedId} className="flex-1 lg:flex-none flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-900 disabled:bg-slate-100 disabled:text-slate-400 text-white font-medium text-sm py-2 px-4 rounded-lg transition-colors shadow-sm"><Edit2 size={16} /><span>Update</span></button>
          <button onClick={() => { setData(data.filter(d => d.id !== selectedId)); clearForm(); }} disabled={!selectedId} className="flex-1 lg:flex-none flex items-center justify-center gap-2 bg-rose-50 text-rose-600 hover:bg-rose-100 disabled:bg-slate-100 disabled:text-slate-400 font-medium text-sm py-2 px-4 rounded-lg transition-colors"><Trash2 size={16} /><span>Delete</span></button>
          {selectedId && <button onClick={clearForm} className="text-xs text-slate-500 hover:text-slate-800 underline px-2 self-center">Cancel</button>}
        </div>
      </div>

      {/* Website Responsive Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500 font-medium bg-slate-50/50">
              {['Group Code', 'Description', 'Type', 'Prefix', 'Sales %', 'Comm%', 'SerailNo'].map((col, i) => <th key={i} className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400">{col}</th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-slate-700">
            {data.map(item => (
              <tr key={item.id} onClick={() => handleRowClick(item)} className={`group cursor-pointer transition-colors ${selectedId === item.id ? 'bg-indigo-50/70 text-indigo-900 font-medium' : 'hover:bg-slate-50'}`}>
                <td className="px-6 py-3.5 font-medium text-slate-900">{item.code}</td>
                <td className="px-6 py-3.5 text-slate-600">{item.name}</td>
                <td className="px-6 py-3.5 text-slate-400 italic">{item.type || '—'}</td>
                <td className="px-6 py-3.5 font-mono text-xs">{item.prefix || '—'}</td>
                <td className="px-6 py-3.5 text-slate-500">{item.sales || '—'}</td>
                <td className="px-6 py-3.5 text-slate-500">{item.comn || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="bg-slate-50 border-t border-slate-100 px-6 py-3 text-xs text-slate-400 flex justify-between items-center">
        <span>Click any row to populate data properties above for updates.</span>
        <span>Total Records: <strong className="text-slate-700">{data.length}</strong></span>
      </div>
    </div>
  );
}